import React from 'react'
import styled from 'styled-components'
import { Option, SelectTypeEnum } from './types'
import { Checkbox, Input, Radio, Select } from '@seiue/ui'
import { FieldTypeEnum } from 'packages/sdks-next/growp'
import { LabelEllipsis } from './LabelEllipsis'

/**
 * 单选|多选 - 选项
 *
 * @param param - 参数
 * @param param.options - 选项
 * @param param.otherRequire - 其它内容是否必填
 * @param param.type - 类型
 * @param param.selectType - 当前选项类型
 * @returns React.ReactNode
 */
export const OptionList: React.FC<{
  options: Option[]
  otherRequire?: boolean
  type: FieldTypeEnum.Single | FieldTypeEnum.Multi
  selectType: SelectTypeEnum
}> = ({ options, type, selectType }) => {
  return (
    <Wrapper>
      {selectType === SelectTypeEnum.DropDown ? (
        <Select
          placeholder="请选择"
          disabled
          options={options}
        />
      ) : (
        <>
          {options.map((option) => {
            return (
              <OptionWrapper key={option.value}>
                <OptionLeftWrapper>
                  {option.value === '其它' ? (
                    <>
                      {type === FieldTypeEnum.Single ? (
                        <Radio disabled />
                      ) : (
                        <Checkbox
                          disabled
                          style={{ marginRight: '8px' }}
                        />
                      )}
                      <OtherWrapper>
                        <OtherLabel>其它</OtherLabel>
                        <Input
                          disabled
                          style={{
                            width: '614px',
                          }}
                        />
                      </OtherWrapper>
                    </>
                  ) : (
                    <LabelEllipsis
                      type={type}
                      label={option.label}
                    />
                    // 勿删 后续可能会用
                    // <Input
                    //   underlined
                    //   disabled
                    //   addonBefore={
                    //     type === FieldTypeEnum.Single ? (
                    //       <Radio disabled />
                    //     ) : (
                    //       <Checkbox disabled />
                    //     )
                    //   }
                    //   value={option.label}
                    // />
                  )}
                </OptionLeftWrapper>
              </OptionWrapper>
            )
          })}
        </>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`

const OptionLeftWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
`

const OptionWrapper = styled.div`
  width: 100%;
  height: 26px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &&& {
    .ant-input-group-wrapper {
      width: 648px;
      border-bottom: 1px solid transparent;
    }
    .ant-input-group {
      .ant-input,
      .ant-input-group-addon {
        background-color: transparent;
        border: none;
        height: 26px;
      }
      .ant-input-group-addon {
        padding: 0 0;
        width: 20px;
      }
      .ant-input {
        padding-left: 0;
        max-width: 600px;
      }
      .ant-checkbox-wrapper {
        margin-right: 8px;
      }
    }
  }
`

const OtherWrapper = styled.div`
  .ant-input {
    height: 32px !important;
  }
`

const OtherLabel = styled.span`
  display: inline-block;
  width: 28px;
  margin-right: 12px;
  color: rgba(0, 0, 0, 0.25);
`
